import { AbstractControl } from '@angular/forms';

export function noPoBoxValidator(control: AbstractControl) {
    const regex = /^(([a-z][a-z0-9]*\d )?(((p[\.\- ]{0,2}o[\. ]{0,2}((b[\.\- ]{0,2}(ox|in)?))?)|p[\. ]{0,2}b(ox|in)?))([\- ]?#?[0-9]*)?|(?:post ?(?:office ?)?)(b(ox|in))?[\- ]?#?[0-9]*|b(ox|in)[\- ]?#?[0-9]*)$/i;

    return regex.test(control.value && control.value.trim()) ? { noPoBox: true } : null;
}
